import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { NavbarComponent } from "./navbar/navbar.component";
import { ScrollToTopComponent } from "../components/scroll-to-top/scroll-to-top.component";
import { BreadcrumbComponent } from "../components/breadcrumb/breadcrumb.component";
import { NgClass } from "@angular/common";
import { ThemeService } from "../services/theme.service";
import { trigger, transition, style, animate } from "@angular/animations";

import { MenuService } from "../services/menu.service";

@Component({
  selector: "app-layout",
  standalone: true,
  imports: [
    RouterOutlet,
    NgClass,
    SidebarComponent,
    NavbarComponent,
    ScrollToTopComponent,
    BreadcrumbComponent
  ],
  templateUrl: "./layout.component.html",
  styleUrl: "./layout.component.css",
  animations: [
    trigger('routeAnimations', [
      transition('* <=> *', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate('400ms cubic-bezier(0.35, 0, 0.25, 1)', style({ opacity: 1, transform: 'translateY(0)' }))
      ])
    ])
  ]
})
export class LayoutComponent {
  constructor(
    public themeService: ThemeService,
    public menuService: MenuService
  ) { }

  ngOnInit(): void { }

  prepareRoute(outlet: RouterOutlet) {
    return outlet?.activatedRouteData?.['animation'];
  }
}
